import React, { useState } from "react"
import * as common from "./common"
import { yellow } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const Contract = (props) => {
    const { x, y, height, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = yellow[200]
    const defaultColor = fillColor || yellow[100]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    const barOffset = 12

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <rect
                x={x + 1}
                y={y + 1}
                fill={fill}
                stroke={common.outlineColor}
                width={width - 1}
                height={height - 1}
            />

            <line
                x1={x + 1}
                y1={y + barOffset}
                x2={x + width}
                y2={y + barOffset}
                stroke={common.outlineColor}
                strokeWidth={1}
            />

            <line
                x1={x + 1}
                y1={y + height - barOffset}
                x2={x + width}
                y2={y + height - barOffset}
                stroke={common.outlineColor}
                strokeWidth={1}
            />

            <ElementText {...props} label={label} y={props.y + 10} />
        </Svg>
    )
}

export default Contract
